import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { Modal, Select, DatePicker, Icon } from "antd";
import { MODULE_API } from "../../../apis";
import Loader from "../../styled-components/loader/loader";
import "./style/strategy.css";
import { useHistory, useLocation } from "react-router-dom";
import * as Style from "../../../newComponents/styledComponents/styles/ModalStyle";
import addIcon from "../../../assets/images/DeathModuleNew/addIcon.png";
import oneTimeFundingImg from "../../../assets/images/latest/Contributions.png";
import recurringImg from "../../../assets/images/latest/Future-money.png";
import FETCH from "../../../utils/fetch";
import moment from "moment";
import swal from "sweetalert";
import axios from "axios";
const { Option } = Select;

export const Strategy = () => {
  const [showModal, setshowModal] = useState(false);
  const [showModalUpdate, setshowModalUpdate] = useState(false);
  const [updateData, setUpdateData] = useState(null);
  const [showModalRecuring, setshowModalRecuring] = useState(false);
  const [showModalChart, setshowModalChart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [payOffData, setPayOffData] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [snowball, setSnowball] = useState(null);
  const [liabilitiesData, setLiabilitesData] = useState(null);
  const [totalpaid, setTotalPaid] = useState(null);
  const [dataRes, setDataRes] = useState(null);

  const [oneTimeFundingData, setOneTimeFundingData] = useState([]);
  const [frequencyData, setFrequencyData] = useState(null);
  const [oneTimeFunding, setOneTimeFunding] = useState([]);
  const [oneTimeFundingDataUnpaid, setOneTimeFundingDataUnpaid] = useState([]);
  const location = useLocation();
  const history = useHistory();

  const totalMinimumMonthlyPayment = location.total && location.total;
  // const totalMinimumMonthlyPayment = location.total && !isNaN(location.total) ? location.total : 0;

  const closeUpdate = () => {
    setshowModalUpdate(false);
  };
  const openUpdate = () => {
    setshowModalUpdate(true);
  };

  const close = () => {
    setshowModal(false);
  };
  const open = () => {
    setshowModal(true);
  };
  const handleSubmit = async () => {
    setshowModal(false);
    console.log("formData submit", formData);
    try {
      setLoading(true);
      const res = await MODULE_API.createOneTimePayment({
        payment: +formData.payment,
        nickname: formData.nickname,
        date: formData.date && moment(formData.date).format("YYYY-MM-DD"),
      });
      setLoading(false);
      console.log("ressss", res);
      if (res.status && res.status === 200) {
        swal("Success", res.message, "success");
      } else if (res.status && res.status === 400) {
        swal("Error", res.message, "error");
      }
      await getOneTimeFundingPayment();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    setFormData(null);
  };

  const handleSubmitUpdate = async () => {
    setshowModalUpdate(false);
    console.log("handleChangeUpdate submit", updateData);
    try {
      setLoading(true);
      const res = await MODULE_API.UpdateOneTimePayment({
        ...updateData,
        payment: +updateData.payment,
        nickname: updateData.nickname,
        date: updateData.date && moment(updateData.date).format("YYYY-MM-DD"),
      });
      setLoading(false);
      console.log("ressss", res);
      if (res.status && res.status === 200) {
        swal("Success", res.message, "success");
      } else if (res.status && res.status === 400) {
        swal("Error", res.message, "error");
      }
      await getOneTimeFundingPayment();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    setFormData(null);
    setUpdateData(null);
  };
  const handleDeleteOneTime = async (id) => {
    try {
      setLoading(true);
      const res = await MODULE_API.DeleteOneTimePayment(id);
      setLoading(false);
      console.log("ressss", res);
      if (res.status && res.status === 200) {
        swal("Deleted", res.message, "success");
      } else if (res.status && res.status === 400) {
        swal("Error", res.message, "error");
      }
      await getOneTimeFundingPayment();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const createPayOff = async (strategy) => {
    try {
      setLoading(true);
      const res = await MODULE_API.createPayOffData({
        // "amount": 300,
        snowball: payOffData && payOffData[0] && payOffData[0].snowball,
        strategy: strategy,
      });
      setLoading(false);
      console.log("ressss", res);
      getDebtPayOff();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    setFormData(null);
  };

  const closeRecuring = () => {
    setshowModalRecuring(false);
    setFormData(null);
  };
  const openRecuring = () => {
    setshowModalRecuring(true);
  };
  const handleSubmitRecuring = async () => {
    setshowModalRecuring(false);
    console.log("formData submit", formData);
    let payload={
      frequency:formData && formData.frequency || frequencyData && frequencyData.frequency,
      startDate:formData && formData.startDate || frequencyData && frequencyData.startDate
    }
    try {
      setLoading(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl="https://0bbkesatv9.execute-api.us-east-1.amazonaws.com";
      const response = await axios.post(
        `${baseUrl}/Prod/debt/frequency`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response",response);
      await getFrequncy();
      setLoading(false);
    } catch (error) {
      setLoading(false);
     
      console.error("Error fetching user data:", error);
    }
    setFormData(null);
  };
  const getFrequncy = async () => {
    try {
      setLoading(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl="https://0bbkesatv9.execute-api.us-east-1.amazonaws.com";
      const response = await axios.get(
        `${baseUrl}/Prod/debt/frequency`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response",response.data.data);
      if(response && response.data && response.data.status===200 && response.data.data){
        setFrequencyData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const closeChart = () => {
    setshowModalChart(false);
  };
  const openChart = () => {
    setshowModalChart(true);
  };
  const handleSubmitChart = async () => {
    setshowModalChart(false);
    try {
      setLoading(true);
      const res = await MODULE_API.createPayOffData({
        snowball: +formData.Extra,
        strategy: payOffData && payOffData[0] && payOffData[0].strategy,
      });
      setLoading(false);
      console.log("ressss", res);
      getDebtPayOff();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    setFormData(null);
  };
  const options = ["Weekly", "Bi-weekly", "Monthly", "Bi-monthly"];

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleChangeUpdate = (name, value) => {
    setUpdateData({
      ...updateData,
      [name]: value,
    });
  };
  const getOneTimeFundingPayment = async () => {
    try {
      setLoading(true);
      const response = await MODULE_API.getOneTimeFunding();
      if (response && response.data) {
        setOneTimeFundingData(
          response.data.filter((item) => item.paid === true)
        );
        setOneTimeFundingDataUnpaid(
          response.data.filter((item) => item.paid === false)
        );
        setOneTimeFunding(response.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error getting OneTimeFundingFromServer:", error);
    }
  };

  const getLiabilitesList = async () => {
    try {
      (async () => {
        setLoading(true);
        let datares = await FETCH.post({
          url: "client-module-service/client-module/list",
          id: `?module=Liabilities and Credit&page=1&limit=10`,
          body: {},
        });
        setLoading(false);
        if (datares && datares.records) {
          datares.records.map((item) => {
            if (item.subType == "Credit") {
              item["Nickname of Liabilities"] = item["Nickname of Credit"];
              item["Initial Loan Amount"] = item["Credit Balance"];
              item["Interest Rate"] = item["Interest Rate (or APR%)"];
              item["Maturity Date"] = item["Point Expiration"];
              item["Monthly Payment"] =
                item["Monthly Payment"] && item["Monthly Payment"].toString();
              item["Start Date"] = new Date();
            }
          });

          setLiabilitesData(datares.records);
        }
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getDebtPayOff = async () => {
    try {
      (async () => {
        setLoading(true);
        let datares = await MODULE_API.getPayOffData();

        if (datares && datares.data && datares.data.rows) {
          console.log("datares.data.rows", datares.data.rows);
          setPayOffData(datares.data.rows);
          setSnowball(datares.data.rows[0].snowball);
          setSelectedPriority(datares.data.rows[0].strategy);
          setTotalPaid(
            datares.data.rows[0].snowball + totalMinimumMonthlyPayment
          );
        }
        setLoading(false);
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("calling api");
    if (totalMinimumMonthlyPayment === undefined) {
      history.push("/debtPayOff");
    } else {
      // getDebtPayOff();
      // getOneTimeFundingPayment();
      // getLiabilitesList();
      getAll();
    }
  }, []);
  const getAll = async () => {
    await getFrequncy();
    await getDebtPayOff();
    await getOneTimeFundingPayment();
    await getLiabilitesList();
  };

  // handle infinite loop
//   useEffect(() => {
//     if (!liabilitiesData || !oneTimeFunding || !snowball) {
//       console.error("Missing required data.");
//       return;
//     }

//     const myData =
//       selectedPriority === "Highest Interest First"
//         ? liabilitiesData &&
//           liabilitiesData.sort(
//             (a, b) => b["Interest Rate"] - a["Interest Rate"]
//           )
//         : liabilitiesData &&
//           liabilitiesData.sort(
//             (a, b) => a["Initial Loan Amount"] - b["Initial Loan Amount"]
//           );

//     if (!myData || myData.length === 0) {
//       console.error("No liabilities data.");
//       return;
//     }

//     let temp = {};
//     let arrData = [];
//     let keys = [
//       "Month",
//       "One-time Funding",
//       "Snowball",
//       ...myData.map((item) => item["Nickname of Liabilities"]),
//       "End Balance",
//     ];

//     temp["header"] = keys;
//     const arr = myData.map((item) => item["Nickname of Liabilities"]);
//     const arrIdd = myData.map((item) => item.id);
//     const data = {};
//     myData.forEach((item) => {
//       const nickname = item["Nickname of Liabilities"];
//       let monthlyPayment = item["Monthly Payment"] || 0;
//       if (typeof monthlyPayment === 'string') {
//         monthlyPayment = monthlyPayment.replace(/[$,]/g, '').trim();
//       }
//       monthlyPayment = parseFloat(monthlyPayment);
//       if (isNaN(monthlyPayment)) {
//         monthlyPayment = 0;
//       }
//       let initialLoanAmount = item["Initial Loan Amount"] || 0;
//       if (typeof initialLoanAmount === 'string') {
//         initialLoanAmount = initialLoanAmount.replace(/[$,]/g, '').trim();
//       }
//       initialLoanAmount = parseFloat(initialLoanAmount);
//       if (isNaN(initialLoanAmount)) {
//         initialLoanAmount = 0;
//       }
//       let interestRate = item["Interest Rate"] || 0;
//       if (typeof interestRate === 'string') {
//         interestRate = interestRate.replace(/[$,]/g, '').trim();
//       }
//       interestRate = parseFloat(interestRate) / 100;
//       if (isNaN(interestRate)) {
//         interestRate = 0;
//       }
//       data[nickname] = {
//         total: 0,
//         data: [],
//         ILA: initialLoanAmount,
//         InterestRate: interestRate,
//         minimum: monthlyPayment,
//         active: true,
//       };
//     });
//     // myData.forEach((item) => {
//     //   const nickname = item["Nickname of Liabilities"];
//     //   data[nickname] = {
//     //     total: 0,
//     //     data: [],
//     //     ILA: item["Initial Loan Amount"],
//     //     InterestRate: item["Interest Rate"] / 100,
//     //     minimum: parseFloat(item["Monthly Payment"]),
//     //     active: true,
//     //   };
//     // });

//     // let monthlyPayment =
//     //   snowball +
//     //   (myData &&
//     //     myData.reduce(
//     //       (total, item) => total + parseFloat(+item["Monthly Payment"]),
//     //       0
//     //     ));
//     let monthlyPayment = snowball + (
//       myData &&
//       myData.reduce((total, item) => {
//         let payment = item["Monthly Payment"];
//         if (typeof payment === 'string') {
//           payment = payment.replace(/[$,]/g, '').trim();
//         }
//         const parsedPayment = parseFloat(payment);
//         return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
//       }, 0)
//     );
//     let endBalance = 
//       myData &&
//       myData.reduce((total, item) => {
//         let payment = item["Initial Loan Amount"];
//         if (typeof payment === 'string') {
//           payment = payment.replace(/[$,]/g, '').trim();
//         }
//         const parsedPayment = parseFloat(payment);
//         return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
//       }, 0);
//     // let endBalance =
//     //   myData &&
//     //   myData.reduce(
//     //     (total, item) => total + parseFloat(item["Initial Loan Amount"]),
//     //     0
//     //   );

//     let i = 0;
//     let principalPaidSum = 0;
//     let startDate = frequencyData && frequencyData.startDate &&  new Date(frequencyData.startDate) || new Date();
//     let globalArr = [];
//     let newEndBal = endBalance;
//     let otpData = {};
//     oneTimeFunding &&
//       oneTimeFunding.forEach(
//         (val) => (otpData[moment(val.date).format("MMM-YY")] = val.payment)
//       );
//     console.log("here in return");

//     let iterationCount = 0;
//     const maxIterations = 2000; // Set a maximum iteration limit

//     while (
//       Array.isArray(arr) &&
//       arr &&
//       arr.length > 0 
//       &&
//       iterationCount < maxIterations
//     ) {
//       startDate.setMonth(startDate.getMonth() + 1);
//       i++;
//       let obj = {
//         month: moment(startDate).format("MMM-YY"),
//       };
//       let oneTimeMonthFunding = otpData[obj.month] || 0;
//       let snowball = monthlyPayment -
//           Object.values(data).reduce(
//             (a, b) => a + (b.active && b.minimum) || 0,
//             0
//           ) +oneTimeMonthFunding;
//       // let snowball = otpData[obj.month]
//       //   ? otpData[obj.month] - totalMinimumMonthlyPayment
//       //   : monthlyPayment -
//       //     Object.values(data).reduce(
//       //       (a, b) => a + (b.active && b.minimum) || 0,
//       //       0
//       //     );

//       let newsnowball = snowball;
//       console.log("newsnowball",newsnowball)
//       let principalPaidInIteration = 0;

//       arr.forEach((e, index) => {
//         let element = data[e];
//         let monthlyInterestRate = element.InterestRate / 12;
//         let interestRatePaid = element.ILA * monthlyInterestRate;
//         let principal;
//         if (element.ILA <= element.minimum + newsnowball) {
//           element.active = false;
//           principal = element.ILA;
//           let totalPaid = interestRatePaid + principal;
//           snowball =
//             Math.round((element.minimum + snowball - totalPaid) * 100) / 100;
//           newsnowball = snowball;
//         } else {
//           principal = element.minimum + (newsnowball || 0) - interestRatePaid;
//           if (newsnowball > 0) {
//             newsnowball = 0;
//           }
//         }
//         obj[e] = Math.round((interestRatePaid + principal) * 100) / 100;
//         element.total += Math.round(interestRatePaid * 100) / 100;
//         element.ILA -= Math.round(principal * 100) / 100;
//         element.data.push({
//           month: new Date(startDate.getTime() + i * 30 * 24 * 60 * 60 * 1000),
//           totalPaid: Math.round((interestRatePaid + principal) * 100) / 100,
//           snowball,
//           endBalance: Math.round((endBalance - principalPaidSum) * 100) / 100,
//         });
//         data[e] = { ...element, data: [...element.data] };
//         principalPaidInIteration += Math.round(principal * 100) / 100;
//       });

//       let liabilities = Object.keys(data);
//       liabilities.forEach((l) => {
//         obj[l] = (!obj[l] && "") || obj[l];
//       });
//       principalPaidSum += principalPaidInIteration;
//       newEndBal -= principalPaidInIteration;
//       obj["endBalance"] = Math.round(newEndBal * 100) / 100;
//       obj["snowball"] = Math.round(snowball * 100) / 100;
//       obj["oneTimeFunding"] = oneTimeMonthFunding;
      
//       globalArr.push({ ...obj });
// console.log("objjjj",obj)
//       arr.forEach((element, index) => {
//         if (!data[element].active) arr.splice(index, 1);
//       });
//       console.log("here in in while", arr);

//       iterationCount++; // Increment iteration count
//     }

//     if (iterationCount >= maxIterations) {
//       console.error("Exceeded maximum iteration limit. Terminating loop.");
//       return;
//     }

//     console.log("here in outer while",globalArr);
//     globalArr && globalArr.map((input, index) => {
//       let obj = {};
//       Object.keys(data).map((e) => (obj[e] = input[e]));
//       let tableData = {
//         month: input.month,
//         onetime:input["oneTimeFunding"],
//         snowball: input.snowball,
//         ...obj,
//         endBalance: input.endBalance,
//       };
//       arrData.push(Object.values(tableData));
//     });
//     temp["data"] = arrData;
//     console.log("temp",temp)
//     setDataRes(temp);
//   }, [liabilitiesData, selectedPriority, snowball, oneTimeFunding,frequencyData]);
  useEffect(() => {
    if (!liabilitiesData || !oneTimeFunding || !snowball) {
        console.error("Missing required data.");
        return;
    }
    const myData =
        selectedPriority === "Highest Interest First"
            ? liabilitiesData &&
              liabilitiesData.sort(
                  (a, b) => b["Interest Rate"] - a["Interest Rate"]
              )
            : liabilitiesData &&
              liabilitiesData.sort(
                  (a, b) => a["Initial Loan Amount"] - b["Initial Loan Amount"]
              );
    if (!myData || myData.length === 0) {
        console.error("No liabilities data.");
        return;
    }
    let temp = {};
    let arrData = [];
    let keys = [
        "Month", // Default key, can be adjusted based on frequency
        "One-time Funding",
        "Snowball",
        ...myData.map((item) => item["Nickname of Liabilities"]),
        "End Balance",
    ];
    temp["header"] = keys;
    const arr = myData.map((item) => item["Nickname of Liabilities"]);
    const data = {};
    myData.forEach((item) => {
        const nickname = item["Nickname of Liabilities"];
        let monthlyPayment = item["Monthly Payment"] || 0;
        if (typeof monthlyPayment === 'string') {
            monthlyPayment = monthlyPayment.replace(/[$,]/g, '').trim();
        }
        monthlyPayment = parseFloat(monthlyPayment);
        if (isNaN(monthlyPayment)) {
            monthlyPayment = 0;
        }
        let initialLoanAmount = item["Initial Loan Amount"] || 0;
        if (typeof initialLoanAmount === 'string') {
            initialLoanAmount = initialLoanAmount.replace(/[$,]/g, '').trim();
        }
        initialLoanAmount = parseFloat(initialLoanAmount);
        if (isNaN(initialLoanAmount)) {
            initialLoanAmount = 0;
        }
        let interestRate = item["Interest Rate"] || 0;
        if (typeof interestRate === 'string') {
            interestRate = interestRate.replace(/[$,]/g, '').trim();
        }
        interestRate = parseFloat(interestRate) / 100;
        if (isNaN(interestRate)) {
            interestRate = 0;
        }
        data[nickname] = {
            total: 0,
            data: [],
            ILA: initialLoanAmount,
            InterestRate: interestRate,
            minimum: monthlyPayment,
            active: true,
        };
    });
    let monthlyPayment = snowball + (
        myData &&
        myData.reduce((total, item) => {
            let payment = item["Monthly Payment"];
            if (typeof payment === 'string') {
                payment = payment.replace(/[$,]/g, '').trim();
            }
            const parsedPayment = parseFloat(payment);
            return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
        }, 0)
    );
    let endBalance =
        myData &&
        myData.reduce((total, item) => {
            let payment = item["Initial Loan Amount"];
            if (typeof payment === 'string') {
                payment = payment.replace(/[$,]/g, '').trim();
            }
            const parsedPayment = parseFloat(payment);
            return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
        }, 0);
    let i = 0;
    let principalPaidSum = 0;
    let startDate = frequencyData && frequencyData.startDate && new Date(frequencyData.startDate) || new Date();
    let globalArr = [];
    let newEndBal = endBalance;
    let otpData = {};
    oneTimeFunding &&
        oneTimeFunding.forEach(
            (val) => (otpData[moment(val.date).format("MM-DD-YYYY")] = val.payment)
        );
    let iterationCount = 0;
    const maxIterations = 2000; // Set a maximum iteration limit
    while (
        Array.isArray(arr) &&
        arr &&
        arr.length > 0 &&
        iterationCount < maxIterations
    ) {
        // Adjusting date increments based on frequency
        if (frequencyData && frequencyData.frequency === 'Weekly') {
            startDate.setDate(startDate.getDate() + 7); // Increment by 7 days for weekly
        } else if (frequencyData && frequencyData.frequency === 'Bi-weekly') {
            startDate.setDate(startDate.getDate() + 15); // Increment by 15 days for bi-weekly
        } else if (frequencyData && frequencyData.frequency === 'Monthly') {
            startDate.setMonth(startDate.getMonth() + 1); // Increment by 1 month for monthly
        } else if (frequencyData && frequencyData.frequency === 'Bi-monthly') {
            startDate.setDate(startDate.getMonth() + 2); // Increment by 60 days for bi-monthly
        }
        else{
          startDate.setMonth(startDate.getMonth() + 1);
        }
        i++;
        let obj = {
            week: frequencyData && frequencyData.frequency === 'Weekly' ? moment(startDate).format("MM-DD-YYYY") :
                  frequencyData && frequencyData.frequency === 'Bi-weekly' ? moment(startDate).format("MM-DD-YYYY") :
                  moment(startDate).format("MM-DD-YYYY"), // Adjust format based on frequency
        };
        console.log("obj.week",obj.week,otpData)
        // Parse the dates
        let weekDate = obj.week && new Date(obj.week);
        // Extract month and year
        let weekMonth = weekDate && weekDate.getMonth(); // 0-11 (January is 0, December is 11)
        let weekYear = weekDate && weekDate.getFullYear();
        let oneTimeMonthFunding = 0;
          // Iterate through the otpData keys
          for (let dateStr in otpData) {
            let otpDate = new Date(dateStr);
            let otpMonth =otpDate && otpDate.getMonth();
            let otpYear =otpDate && otpDate.getFullYear();
            // Compare month and year
            if (weekMonth === otpMonth && weekYear === otpYear) {
              oneTimeMonthFunding = otpData[dateStr];
              break;  // Break out of the loop once a match is found
            }
          }

        // let oneTimeMonthFunding = otpData[obj.week] || 0;
        let snowball = monthlyPayment -
            Object.values(data).reduce(
                (a, b) => a + (b.active && b.minimum) || 0,
                0
            ) + oneTimeMonthFunding;
        let newsnowball = snowball;
        let principalPaidInIteration = 0;
        arr.forEach((e, index) => {
            let element = data[e];
            let monthlyInterestRate = element.InterestRate / 12;
            let interestRatePaid = element.ILA * monthlyInterestRate;
            let principal;
            if (element.ILA <= element.minimum + newsnowball) {
                element.active = false;
                principal = element.ILA;
                let totalPaid = interestRatePaid + principal;
                snowball =
                    Math.round((element.minimum + snowball - totalPaid) * 100) / 100;
                newsnowball = snowball;
            } else {
                principal = element.minimum + (newsnowball || 0) - interestRatePaid;
                if (newsnowball > 0) {
                    newsnowball = 0;
                }
            }
            obj[e] = Math.round((interestRatePaid + principal) * 100) / 100;
            element.total += Math.round(interestRatePaid * 100) / 100;
            element.ILA -= Math.round(principal * 100) / 100;
            element.data.push({
                week: new Date(startDate), // Date adjustment logic
                totalPaid: Math.round((interestRatePaid + principal) * 100) / 100,
                snowball,
                endBalance: Math.round((endBalance - principalPaidSum) * 100) / 100,
            });
            data[e] = { ...element, data: [...element.data] };
            principalPaidInIteration += Math.round(principal * 100) / 100;
        });
        let liabilities = Object.keys(data);
        liabilities.forEach((l) => {
            obj[l] = (!obj[l] && "") || obj[l];
        });
        principalPaidSum += principalPaidInIteration;
        newEndBal -= principalPaidInIteration;
        obj["endBalance"] = Math.round(newEndBal * 100) / 100;
        obj["snowball"] = Math.round(snowball * 100) / 100;
        obj["oneTimeFunding"] = oneTimeMonthFunding;
        globalArr.push({ ...obj });
        arr.forEach((element, index) => {
            if (!data[element].active) arr.splice(index, 1);
        });
        iterationCount++; // Increment iteration count
    }
    if (iterationCount >= maxIterations) {
        console.error("Exceeded maximum iteration limit. Terminating loop.");
        return;
    }
    globalArr && globalArr.map((input, index) => {
        let obj = {};
        Object.keys(data).map((e) => (obj[e] = input[e]));
        let tableData = {
            week: input.week, // Changed from "month" to "week"
            onetime: input["oneTimeFunding"],
            snowball: input.snowball,
            ...obj,
            endBalance: input.endBalance,
        };
        arrData.push(Object.values(tableData));
    });
    temp["data"] = arrData;
    setDataRes(temp);
  }, [liabilitiesData, selectedPriority, snowball, oneTimeFunding, frequencyData]);
  
  // not hanlde infine previous wasiq code
  // useEffect(() => {
  //   if (!liabilitiesData || !oneTimeFundingData || !snowball) {
  //     console.error("Missing required data."); // Logging error for missing data
  //     return;
  //   }
  //   const myData =
  //     selectedPriority == "Highest Interest First"
  //       ? liabilitiesData &&
  //         liabilitiesData.sort(
  //           (a, b) => b["Interest Rate"] - a["Interest Rate"]
  //         )
  //       : liabilitiesData &&
  //         liabilitiesData.sort(
  //           (a, b) => a["Initial Loan Amount"] - b["Initial Loan Amount"]
  //         );
  //   let temp = {};
  //   let arrData = [];
  //   let keys = [];
  //   if (myData) {
  //     keys = [
  //       "Month",
  //       "Snowball",
  //       ...myData.map((item) => item["Nickname of Liabilities"]),
  //       "End Balance",
  //     ];
  //   }

  //   temp["header"] = keys;
  //   let arr = myData && myData.map((item) => item["Nickname of Liabilities"]);
  //   const data = {};
  //   myData &&
  //     myData.forEach((item) => {
  //       const nickname = item["Nickname of Liabilities"];
  //       data[nickname] = {
  //         total: 0,
  //         data: [],
  //         ILA: item["Initial Loan Amount"],
  //         InterestRate: item["Interest Rate"] / 100,
  //         minimum: parseFloat(item["Monthly Payment"]),
  //         active: true,
  //       };
  //     });

  //   let monthlyPayment =
  //     snowball +
  //     (myData &&
  //       myData.reduce(
  //         (total, item) => total + parseFloat(item["Monthly Payment"]),
  //         0
  //       ));

  //   let endBalance =
  //     myData &&
  //     myData.reduce(
  //       (total, item) => total + parseFloat(item["Initial Loan Amount"]),
  //       0
  //     );

  //   let i = 0;
  //   let principalPaidSum = 0;
  //   let startDate = new Date("2022-01-01T00:00:00.000Z");
  //   let globalArr = [];
  //   let newEndBal = endBalance;
  //   let otpData = {};
  //   oneTimeFundingData && oneTimeFundingData.forEach(
  //     (val) => (otpData[moment(val.date).format("MMM-YY")] = val.payment)
  //   );
  //   console.log("here in return");

  //   while (Array.isArray(arr) && arr && arr.length > 0) {
  //     startDate.setMonth(startDate.getMonth() + 1);
  //     i++;
  //     let obj = {
  //       month: moment(startDate).format("MMM-YY"),
  //     };
  //     let snowball = otpData[obj.month]
  //       ? otpData[obj.month] - totalMinimumMonthlyPayment
  //       : monthlyPayment -
  //         Object.values(data).reduce(
  //           (a, b) => a + (b.active && b.minimum) || 0,
  //           0
  //         );

  //     let newsnowball = snowball;
  //     let principalPaidInIteration = 0;

  //     arr.forEach((e, index) => {
  //       let element = data[e];
  //       let monthlyInterestRate = element.InterestRate / 12;
  //       let interestRatePaid = element.ILA * monthlyInterestRate;
  //       let principal;
  //       if (element.ILA <= element.minimum + newsnowball) {
  //         element.active = false;
  //         principal = element.ILA;
  //         let totalPaid = interestRatePaid + principal;
  //         snowball =
  //           Math.round((element.minimum + snowball - totalPaid) * 100) / 100;
  //         newsnowball = snowball;
  //       } else {
  //         principal = element.minimum + (newsnowball || 0) - interestRatePaid;
  //         if (newsnowball > 0) {
  //           newsnowball = 0;
  //         }
  //       }
  //       obj[e] = Math.round((interestRatePaid + principal) * 100) / 100;
  //       element.total += Math.round(interestRatePaid * 100) / 100;
  //       element.ILA -= Math.round(principal * 100) / 100;
  //       element.data.push({
  //         month: new Date(startDate.getTime() + i * 30 * 24 * 60 * 60 * 1000),
  //         totalPaid: Math.round((interestRatePaid + principal) * 100) / 100,
  //         snowball,
  //         endBalance: Math.round((endBalance - principalPaidSum) * 100) / 100,
  //       });
  //       data[e] = { ...element, data: [...element.data] };
  //       principalPaidInIteration += Math.round(principal * 100) / 100;
  //     });

  //     let liabilities = Object.keys(data);
  //     liabilities.forEach((l) => {
  //       obj[l] = (!obj[l] && "") || obj[l];
  //     });
  //     principalPaidSum += principalPaidInIteration;
  //     newEndBal -= principalPaidInIteration;

  //     obj["endBalance"] = Math.round(newEndBal * 100) / 100;
  //     obj["snowball"] = Math.round(snowball * 100) / 100;

  //     globalArr.push({ ...obj });

  //     arr.forEach((element, index) => {
  //       if (!data[element].active) arr.splice(index, 1);
  //     });
  //     console.log("here in in while",arr);
  //     // return
  //   }
  //   console.log("here in outer while");
  //   globalArr.map((input, index) => {
  //     let obj = {};
  //     Object.keys(data).map((e) => (obj[e] = input[e]));
  //     let tableData = {
  //       month: input.month,
  //       snowball: input.snowball,
  //       ...obj,
  //       endBalance: input.endBalance,
  //     };
  //     arrData.push(Object.values(tableData));
  //   });
  //   temp["data"] = arrData;
  //   setDataRes(temp);
  // }, [liabilitiesData, selectedPriority, snowball, oneTimeFundingData]);

  const data = {
    labels: ["$5000", "$10000", "$15000", "$20000", "$25000", "$30000"],
    datasets: [
      {
        label: "First dataset",
        data: [33, 53, 85, 41, 44, 65],
        fill: true,
        backgroundColor: "#E6F1FF",
        borderColor: "#2A3DA3",
      },
      {
        label: "First dataset",
        data: [23, 63, 45, 80, 55, 73],
        fill: true,
        backgroundColor: "#E6F1FF",
        borderColor: "red",
      },
    ],
  };

  return (
    <div>
      <div className="MainDebtDashboard" style={{ flexDirection: "column" }}>
        <div className="cardHeadingDebt">Strategy</div>
        <div style={{ color: "#878686" }}>Optimize your Payoff plan</div>
      </div>
      <div className="MainDebtDashboard">
        <div className="cardContainer">
          <div className="strategyCard">
            <div
              className="cardHeadingDebt"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{ display: "flex", gap: "8px" }}>
                <img
                  src={recurringImg}
                  style={{ height: "40px", width: "40px" }}
                  height={20}
                  width={20}
                  alt="onetime"
                ></img>
                <div>
                  Monthly Payment
                  <div style={{ color: "#878686", fontSize: "14px" }}>
                    Including Extra Amount
                  </div>
                </div>
              </div>
              <div
                className="AddButton"
                onClick={() => {
                  openRecuring();
                }}
              >
                <img src={addIcon} alt="addicon"></img>
              </div>
            </div>
            {/* <div style={{ color: "#878686" }}>
              Amount use for making payment each cycle.
              </div> */}
            <div className="cardHeadingDebt" style={{ marginTop: "1rem" }}>
              Frequency
            </div>
            <div style={{ color: "#878686" }}>
            {frequencyData && frequencyData.frequency} {frequencyData && "on the"} {frequencyData && frequencyData.startDate &&  moment(frequencyData.startDate).format("Do")}
            </div>
            <div className="cardHeadingDebt" style={{ marginTop: "1rem" }}>
              Amount
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <div style={{ color: "#878686" }}>Minimum</div>$
              {totalMinimumMonthlyPayment &&
                totalMinimumMonthlyPayment
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <div style={{ color: "#878686" }}>Extra</div>
              <div style={{ display: "flex", gap: "1rem" }}>
                $
                {payOffData &&
                  payOffData[0] &&
                  payOffData[0].snowball &&
                  payOffData[0].snowball
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                <div
                  className="AddButton"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    openChart();
                  }}
                >
                  <img src={addIcon} alt="addicon"></img>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                borderTop: "1px solid gray",
                marginTop: "1rem",
              }}
            >
              <div style={{ color: "#878686" }}>Total</div>$
              {totalpaid &&
                totalpaid
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </div>
          </div>

          <div className="strategyCard">
            <div
              className="cardHeadingDebt"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{ display: "flex", gap: "8px" }}>
                <img
                  src={oneTimeFundingImg}
                  style={{ height: "40px", width: "50px" }}
                  height={20}
                  width={20}
                  alt="onetime"
                ></img>
                <div>
                  One-Time Payments
                  {/*   <div style={{ color: "#878686",fontSize: "14px" }}>
              Bonus amounts for making payments
              </div>*/}
                </div>
              </div>
              <div
                className="AddButton"
                onClick={() => {
                  open();
                }}
              >
                <img src={addIcon} alt="addicon"></img>
              </div>
            </div>
            {/*<div style={{ color: "#878686" }}>
              Bonus amounts for making payments
              </div> */}
            <div className="listingContainer">
              <React.Fragment>
                {oneTimeFundingDataUnpaid &&
                oneTimeFundingDataUnpaid.length > 0 ? (
                  oneTimeFundingDataUnpaid.map((item, index) => (
                    <div
                      key={index}
                      className="list-row-noBg"
                      style={{ display: "flex",alignItems:"center" }}
                    >
                      <div className="listname-dark">
                        <div>
                          {item.date && moment(item.date).format("MM-DD-YYYY")}
                        </div>
                       {/* <div style={{ color: "#26C0E2", fontWeight: "400" }}>
                          $
                          {item.payment
                            ? item.payment &&
                              item.payment
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0"}
                          </div> */}
                      </div>
                      <div style={{ color: "#000000", fontWeight: "500" }} >
                        {/*item.paid ? "Paid" : "UnPaid" */}
                        $
                        {item.payment
                          ? item.payment &&
                          parseFloat(item.payment)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0"}
                      </div>
                      <div style={{ display: "flex" }}>
                        <div>
                          <Icon
                            type="edit"
                            onClick={() => {
                              setUpdateData(item);
                              openUpdate();
                            }}
                            style={{
                              padding: "5px",
                              fontSize: "22px",
                              color: "#2a3da3",
                            }}
                          />
                        </div>
                        <div>
                          <Icon
                            type="delete"
                            onClick={() => {
                              handleDeleteOneTime(item.id);
                            }}
                            style={{
                              padding: "5px",
                              fontSize: "22px",
                              color: "#2a3da3",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="nodata">No Data to Show</div>
                )}
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>
      {/*<div className="MainDebtDashboard" style={{ flexDirection: "column" }}>
        <div
          className="cardHeadingDebt"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "30%",
          }}
        >
          Extra Payment Priority
          <div
            className="AddButton"
            style={{ cursor: "pointer" }}
            onClick={() => {
              openChart();
            }}
          >
            <img src={addIcon} alt="addicon"></img>
          </div> 
        </div>
        <div style={{ color: "#878686" }}>
          Which debts get extra payment first
        </div>
      </div>*/}
      <div className="MainDebtDashboard">
        {payOffData &&
          payOffData.map((item, index) => (
            <div key={index} className="strategyCard1">
              <div className="cardHeadingDebt">Highest Interest First</div>
              {item.strategy === "Highest Interest First" ? (
                <div className="selectedbutton">Selected</div>
              ) : (
                <div
                  className="selectbutton"
                  onClick={() => {
                    createPayOff("Highest Interest First");
                  }}
                >
                  Select
                </div>
              )}
            </div>
          ))}
        {payOffData &&
          payOffData.map((item, index) => (
            <div key={index} className="strategyCard1">
              <div className="cardHeadingDebt">Lowest Balance First</div>
              {item.strategy === "Lowest Balance First" ? (
                <div className="selectedbutton">Selected</div>
              ) : (
                <div
                  className="selectbutton"
                  onClick={() => {
                    createPayOff("Lowest Balance First");
                  }}
                >
                  Select
                </div>
              )}
            </div>
          ))}
      </div>
      <div style={{ padding: "1rem" }}>
        <div
          className=""
          style={{
            width: "100%",
            padding: "1rem",
            background: "white",
            borderRadius: "8px",
          }}
        >
          <div className="cardHeadingDebt">Amortization Listing</div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              height: "21rem",
            }}
          >
            {console.log("dataRes.header", dataRes && dataRes.header)}
            {dataRes && dataRes.header && dataRes.header.length > 0 ? (
              <div className="ContactTableConatier">
                <div style={{ height: "23rem" }}>
                  <table className="ContactTable">
                    <thead>
                      <tr className="ContactTable-Row">
                        {dataRes.header.map((header1, index) => (
                          <th className="ContactTable-data" key={index}>
                            {header1}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="ContactTable-body">
                      {dataRes &&
                        dataRes.data &&
                        dataRes.data.map((strikeSet, index) => (
                          <tr key={index}>
                            {strikeSet.map((strike, innerIndex) => (
                              <td
                                className="ContactTable-data"
                                key={innerIndex}
                              >
                                {strike ? strike : "N/A"}
                              </td>
                            ))}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "700",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  flexDirection: "column",
                }}
              >
                No List to Show
              </div>
            )}
          </div>
        </div>
      </div>

      {showModalChart && (
        <Modal footer={null} closable={false} visible={showModalChart} centered>
          <Style.HeaderConatiner>
            <Style.ModalTitle>
              Recurring funding for extra payment
            </Style.ModalTitle>
          </Style.HeaderConatiner>
          <div
            style={{
              maxHeight: "25rem",
              overflow: "scroll",
              padding: "1rem",
            }}
          >
            <div style={{ marginTop: "1rem" }}>
              <Line
                data={data}
                options={{
                  legend: {
                    display: false,
                  },
                  scales: {
                    xAxes: [
                      {
                        gridLines: {
                          color: "rgba(0, 0, 0, 0)",
                        },
                      },
                    ],
                    yAxes: [
                      {
                        gridLines: {
                          color: "rgba(0, 0, 0, 0)",
                        },
                      },
                    ],
                  },
                  plugins: {},
                }}
              />
            </div>

            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Extra</Style.FieldsTitle>
              <Style.Input
                defaultValue={null}
                value={formData && formData.Extra}
                name="Extra"
                onChange={(e) => {
                  e.preventDefault();
                  const result = e.target.value.replace(/\D/g, "");
                  let decimalNumber = e.target.value.replace(
                    /^-?\D*(\.\D*)?$/,
                    ""
                  );
                  handleChange(e.target.name, decimalNumber);
                }}
                size="large"
                placeholder={`Extra`}
              ></Style.Input>
            </div>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton
              onClick={() => {
                closeChart();
                setFormData({});
              }}
            >
              Cancel
            </Style.CancelButton>
            <Style.SaveButton onClick={handleSubmitChart}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      {showModalRecuring && (
        <Modal
          footer={null}
          closable={false}
          visible={showModalRecuring}
          centered
        >
          <Style.HeaderConatiner>
            <Style.ModalTitle> Recurring Funding</Style.ModalTitle>
          </Style.HeaderConatiner>
          <div
            style={{
              maxHeight: "25rem",
              overflow: "scroll",
              padding: "1rem",
            }}
          >
            <div>
              <Style.FieldsTitle>Frequency</Style.FieldsTitle>
              <Select
                showSearch
                placeholder="Frequency"
                listHeight="120"
                name="Frequency"
                value={formData && formData.frequency || frequencyData && frequencyData.frequency}
                onChange={(value) => {
                  handleChange("frequency", value);
                  // setFrequencyData({
                  //   ...frequencyData,
                  //   ["frequency"]: value,
                  // });
                }}
              >
                {options &&
                  options.map((item, index) => {
                    return (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    );
                  })}
              </Select>
            </div>

            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Start date</Style.FieldsTitle>
              <DatePicker
                size="large"
                style={{
                  width: "100%",
                  border: "1px solid #d1d5db",
                  borderRadius: "5px",
                }}
                format={"MM/DD/YYYY"}
                placeholder={"Start date"}
                name={"Start date"}
                id="newDate"
                value={formData && formData.startDate && moment(formData.startDate) || frequencyData && frequencyData.startDate && moment(frequencyData.startDate) }
                onChange={(date, dateString) => {
                  // setFrequencyData({
                  //   ...frequencyData,
                  //   ["startDate"]: dateString,
                  // });
                  handleChange("startDate", dateString);
                }}
              />
            </div>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton
              onClick={() => {
                closeRecuring();
              }}
            >
              Cancel
            </Style.CancelButton>
            <Style.SaveButton onClick={handleSubmitRecuring}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      {showModal && (
        <Modal footer={null} closable={false} visible={showModal} centered>
          <Style.HeaderConatiner>
            <Style.ModalTitle> One-Time Funding</Style.ModalTitle>
          </Style.HeaderConatiner>
          <div
            style={{
              maxHeight: "25rem",
              overflow: "scroll",
              padding: "1rem",
            }}
          >
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Nickname</Style.FieldsTitle>

              <Style.Input
                defaultValue={null}
                value={null}
                name="nickname"
                onChange={(e) => {
                  e.preventDefault();
                  handleChange(e.target.name, e.target.value);
                }}
                size="large"
                placeholder={`Nickname`}
              ></Style.Input>
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Amount</Style.FieldsTitle>

              <Style.Input
                value={formData && formData.payment}
                name="payment"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                onChange={(e) => {
                  e.preventDefault();
                  const result = e.target.value.replace(/\D/g, "");
                  let decimalNumber = e.target.value.replace(
                    /^-?\D*(\.\D*)?$/,
                    ""
                  );

                  handleChange(e.target.name, decimalNumber);

                  // const re = /^(\d*)(\.\d*)?$/g;
                  // let value = e.target.value;
                  // let decimalNumber = value.replace(/^-?\D*(\.\D*)?$/, "");
                }}
                size="large"
                placeholder={`Amount`}
              ></Style.Input>
            </div>

            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Next funding date</Style.FieldsTitle>
              <DatePicker
                size="large"
                style={{
                  width: "100%",
                  border: "1px solid #d1d5db",
                  borderRadius: "5px",
                }}
                format={"MM/DD/YYYY"}
                placeholder={"Next funding date"}
                name="date"
                id="newDate"
                onChange={(date, dateString) => {
                  // handleDatePickerChange("name", dateString);
                  handleChange("date", dateString);
                  // setFormData({
                  //   [name]: dateString,
                  // });
                }}
              />
            </div>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton
              onClick={() => {
                close();
                setFormData(null);
              }}
            >
              Cancel
            </Style.CancelButton>
            <Style.SaveButton onClick={handleSubmit}>Save</Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      {showModalUpdate && (
        <Modal
          footer={null}
          closable={false}
          visible={showModalUpdate}
          centered
        >
          <Style.HeaderConatiner>
            <Style.ModalTitle> One-Time Funding Update</Style.ModalTitle>
          </Style.HeaderConatiner>
          <div
            style={{
              maxHeight: "25rem",
              overflow: "scroll",
              padding: "1rem",
            }}
          >
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Nickname</Style.FieldsTitle>

              <Style.Input
                defaultValue={null}
                value={updateData && updateData.nickname}
                name="nickname"
                onChange={(e) => {
                  e.preventDefault();
                  updateData["nickname"] = e.target.value;
                  handleChangeUpdate(e.target.name, e.target.value);
                }}
                size="large"
                placeholder={`Nickname`}
              ></Style.Input>
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Amount</Style.FieldsTitle>

              <Style.Input
                value={updateData && updateData.payment}
                name="payment"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                onChange={(e) => {
                  e.preventDefault();
                  const result = e.target.value.replace(/\D/g, "");
                  let decimalNumber = e.target.value.replace(
                    /^-?\D*(\.\D*)?$/,
                    ""
                  );
                  updateData["payment"] = decimalNumber;
                  handleChangeUpdate(e.target.name, decimalNumber);

                  // const re = /^(\d*)(\.\d*)?$/g;
                  // let value = e.target.value;
                  // let decimalNumber = value.replace(/^-?\D*(\.\D*)?$/, "");
                }}
                size="large"
                placeholder={`Amount`}
              ></Style.Input>
            </div>

            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Next funding date</Style.FieldsTitle>
              <DatePicker
                size="large"
                style={{
                  width: "100%",
                  border: "1px solid #d1d5db",
                  borderRadius: "5px",
                }}
                value={
                  (formData && formData.date && moment(formData.date)) ||
                  (updateData && updateData.date && moment(updateData.date))
                }
                format={"MM/DD/YYYY"}
                placeholder={"Next funding date"}
                name="date"
                id="newDate"
                onChange={(date, dateString) => {
                  // handleDatePickerChange("name", dateString);
                  handleChangeUpdate("date", dateString);
                  // setUpdateData()
                  setFormData({
                    ["date"]: date,
                  });
                  // setFormData({
                  //   [name]: dateString,
                  // });
                }}
              />
            </div>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton
              onClick={() => {
                closeUpdate();
                setFormData(null);
              }}
            >
              Cancel
            </Style.CancelButton>
            <Style.SaveButton onClick={handleSubmitUpdate}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      <Loader isLoading={loading} />
    </div>
  );
};
